import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d92acc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pass-rate-page" }
const _hoisted_2 = {
  class: "df df-center",
  style: {"margin-bottom":"20px"}
}
const _hoisted_3 = { class: "statistics" }
const _hoisted_4 = { class: "df df-center" }
const _hoisted_5 = { class: "statistics" }
const _hoisted_6 = { class: "df df-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_model_cascader = _resolveComponent("model-cascader")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_process_statistics_year = _resolveComponent("process-statistics-year")!
  const _component_process_statistics_month = _resolveComponent("process-statistics-month")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_model_cascader, {
            onOnChange: _ctx.handleSearch,
            type: "modelOptions",
            placeholder: "请选择设备",
            source: _ctx.requestPayload,
            target: ['', 'modelSpecifications']
          }, null, 8, ["onOnChange", "source"]),
          _createVNode(_component_a_select, {
            value: _ctx.requestPayload.year,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestPayload.year) = $event)),
            options: _ctx.yearOption,
            placeholder: "请选择年度",
            onChange: _ctx.handleSearch,
            allowClear: "",
            style: {"width":"120px"}
          }, null, 8, ["value", "options", "onChange"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.requestPayload.year) + " 年度统计", 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_process_statistics_year, {
        year: _ctx.requestPayload.year,
        statisticsData: _ctx.statisticsData
      }, null, 8, ["year", "statisticsData"])
    ]),
    _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.requestPayload.year) + " 月份统计", 1),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_process_statistics_month, { statisticsData: _ctx.statisticsData }, null, 8, ["statisticsData"])
    ])
  ]))
}